import { Ticket } from '@work4all/models/lib/Classes/Ticket.entity';

import { useTicketToTimeTracking } from '../../../../../../../hooks/use-ticket-to-time-tracking';

import { MaskOverlayTimeTrack } from './MaskOverlayTimeTrack';

export interface BeforeMaskOpen {
  isValid: boolean;
  ticketData: Ticket;
}

export function MaskOverlayTicketTimeTrack({
  ticket,
  menuItemMode = false,
  beforeMaskOpen,
  disabled,
}: {
  ticket?: Ticket;
  menuItemMode?: boolean;
  beforeMaskOpen?: () => Promise<BeforeMaskOpen>;
  disabled?: boolean;
}) {
  const init = useTicketToTimeTracking(ticket);

  return (
    <MaskOverlayTimeTrack
      amplitudeEntryPoint="TicketMask"
      menuItemMode={menuItemMode}
      init={init}
      beforeMaskOpen={beforeMaskOpen}
      disabled={disabled}
    />
  );
}
